<nz-form-item adsptFormInputStates #formItem>
    <nz-form-label>
        <ng-content />
    </nz-form-label>

    <nz-form-control [nzErrorTip]="''">
        <div class="stripe-input ant-input" nz-input #input></div>

        <input class="hidden-input" nz-input [formControlName]="name" />

        <i class="adspt-error-icon">
            <svg class="adspt-icon icon-error">
                <use xlink:href="#adspt-error"></use>
            </svg>
        </i>
    </nz-form-control>
</nz-form-item>
